import { FC } from "react";
import { Routes, Route } from "react-router-dom";
import { Cases } from "./pages/cases";
import { Onboarding } from "./pages/onboarding";
import { useMaintenanceMessage } from "../../shared/maintenance-message";
import { MaintenanceMessage } from "../../shared/maintenance-message/maintenance-message";
import { Skeleton } from "antd";
import {SectionLayoutContainer} from "./section-layout.container";

export const Applicant: FC = () => {
  const { isImpending, isMaintenance } = useMaintenanceMessage();
  const routes = (
    <Routes>
      <Route path="" element={<SectionLayoutContainer />}>
        <Route path="*" element={<Cases />} />
        <Route path="onboarding/*" element={<Onboarding />} />
      </Route>
    </Routes>
  );
  if (isMaintenance === undefined) {
    return <Skeleton />;
  }
  if (isMaintenance) {
    return <MaintenanceMessage />;
  }
  if (isImpending === undefined) return <Skeleton />;

  if (isImpending) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 10,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {routes}
      </div>
    );
  }

  return routes;
};
